import React from 'react'
import { HEADER_BAND_H } from './print-layout'

export interface PrintHeaderBandProps {
  x: number
  y: number
  width: number
  title: string
  status: string
  meta: string
}

/**
 * Title / status / meta band above the body on every page (spec §4). Pure: props in, SVG out —
 * colours and type come from Tailwind classes exactly like `detail/timeline/*`, geometry from
 * attributes, so the PDF inliner can resolve the classes later.
 */
const PrintHeaderBand: React.FC<PrintHeaderBandProps> = ({ x, y, width, title, status, meta }) => (
  <g data-print-header>
    <text x={x} y={y + 18} className="text-base font-semibold fill-foreground">
      {title}
      {status ? <tspan dx={12} className="text-xs font-normal fill-muted-foreground">({status})</tspan> : null}
    </text>
    <text x={x} y={y + 36} className="text-xs fill-muted-foreground">{meta}</text>
    <line x1={x} x2={x + width} y1={y + HEADER_BAND_H - 1} y2={y + HEADER_BAND_H - 1} className="stroke-border" strokeWidth={1} />
  </g>
)

export default PrintHeaderBand
